import { MutationTree } from "vuex";
import { ILoadingState } from './interface';

export default <MutationTree<ILoadingState>> {

	setActive(state: ILoadingState, newVal: boolean) {
		if (newVal) state.loadingCount++;
		else if (state.loadingCount > 0) state.loadingCount--;
	}

}